module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-20.824fd860.jpg";